import angular from "angular";
import {
    REMOTE_CONSOLE_GUI_V2,
    REMOTE_CONSOLE_CLASSIC
} from "@/constants/installations";
import "@/vue/components/modals/VrmRemoteConsoleChoiceModal.vue";

(function() {
    angular
        .module("vrm.core")
        .controller(
            "RemoteConsoleChoiceController",
            RemoteConsoleChoiceController
        );

    /**
     * @constructor
     * @ngInject
     */
    function RemoteConsoleChoiceController(
        $scope,
        $state,
        InstallationsService,
        $stateParams,
        RemoteConsole2Service,
        vrmNotificationsService,
        vrmNotificationType,
        locale,
        $timeout
    ) {
        $scope.installation = null;
        $scope.siteGuiHash = null;
        $scope.showChoiceScreen = true;
        $scope.showV2Console = false;
        $scope.showClassicConsole = false;

        function init() {
            InstallationsService.getInstallation($stateParams.id).then(
                installation => {
                    $scope.installation = installation;
                    $scope.siteGuiHash =
                        installation.gui_hash || installation.identifier;

                    const existingChoice = installation.remoteConsoleChoice;
                    const hasOldGui =
                        installation.view_permissions.rc_classic &&
                        installation.GUIv !== 2;
                    const hasNewGui = installation.view_permissions.rc_gui_v2;

                    if (hasOldGui && hasNewGui && !existingChoice) {
                        $scope.showChoiceScreen = true;
                    } else if (
                        hasNewGui &&
                        existingChoice === REMOTE_CONSOLE_GUI_V2
                    ) {
                        openV2Console();
                    } else if (
                        hasOldGui &&
                        (existingChoice === REMOTE_CONSOLE_CLASSIC ||
                            !hasNewGui)
                    ) {
                        openClassicConsole();
                    } else if (hasNewGui && !hasOldGui) {
                        openV2Console();
                    } else {
                        showNoAccessError();
                    }
                }
            );
        }

        $scope.onChoiceSelected = function(choice) {
            $scope.showChoiceScreen = false;

            if (choice === REMOTE_CONSOLE_GUI_V2) {
                openV2Console();
            } else if (choice === REMOTE_CONSOLE_CLASSIC) {
                openClassicConsole();
            }
        };

        function openV2Console() {
            $scope.showV2Console = true;
            $scope.showChoiceScreen = false;
        }

        function openClassicConsole() {
            locale.ready("remoteconsole").then(function() {
                vrmNotificationsService.add({
                    type: vrmNotificationType.INFO,
                    message:
                        locale.getString(
                            "remoteconsole.opening_classic_console"
                        ) || "Opening classic remote console..."
                });
            });

            $state.go("base.installation-overview", {
                openClassicConsole: true
            });
        }

        $scope.onV2ConsoleClose = function() {
            $scope.showV2Console = false;
            $scope.showChoiceScreen = false;
            $state.go("base.installation-overview");
        };

        function showNoAccessError() {
            locale.ready("core").then(function() {
                vrmNotificationsService.add({
                    type: vrmNotificationType.ERROR,
                    message:
                        locale.getString("core.not_supporting_new_rc") ||
                        "Remote console is not available for this installation"
                });
            });
            $state.go("base.installation-overview");
        }

        init();
    }
})();
